import { useSnackbar } from 'contexts/SnackbarContext';
import { createDeepLinkUrl } from 'utils/deepLink';

const useShare = () => {
    const { showSuccess, showError } = useSnackbar();

    const share = async ({ title, appPath }) => {
        const url = createDeepLinkUrl(appPath);

        if (navigator.share) {
            try {
                await navigator.share({ title, url });
                return;
            } catch (err) {
                if (err.name === 'AbortError') return;
            }
        }

        try {
            await navigator.clipboard.writeText(url);
            showSuccess('링크가 복사되었습니다.');
        } catch (err) {
            showError('링크 복사에 실패했습니다.');
        }
    };

    return { share };
};

export default useShare;
